var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "text-xs-center"
  }, [_c('v-dialog', {
    attrs: {
      "fullscreen": "",
      "persistent": ""
    },
    model: {
      value: _vm.dialog,
      callback: function callback($$v) {
        _vm.dialog = $$v;
      },
      expression: "dialog"
    }
  }, [_c('v-card', {
    staticClass: "risk-assessment scroll-form",
    attrs: {
      "height": "100%"
    }
  }, [_c('v-card-title', {
    staticClass: "headline indigo darken-4 white--text fixed-header",
    attrs: {
      "primary-title": ""
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$vuetify.t('$vuetify.powra.pointOfWorkRiskAssessment').toUpperCase()) + "\n      ")]), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('PowraTitle', {
    attrs: {
      "avatar": 'H',
      "title": _vm.$vuetify.t('$vuetify.powra.carriedOutBy')
    }
  }), _c('v-flex', {
    staticClass: "blue-grey lighten-5",
    attrs: {
      "xs4": ""
    }
  }, [_c('v-card-text', [_c('strong', [_vm._v(_vm._s(_vm.$vuetify.t('$vuetify.powra.name')) + ":")])])], 1), _c('v-flex', {
    staticClass: "blue-grey lighten-5",
    attrs: {
      "xs8": ""
    }
  }, [_vm.user ? _c('v-card-text', [_vm._v("\n            " + _vm._s(_vm.user.full_name) + "\n          ")]) : _vm._e()], 1), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-card-text', [_c('strong', [_vm._v(_vm._s(_vm.$vuetify.t('$vuetify.powra.position')) + ":")])])], 1), _c('v-flex', {
    attrs: {
      "xs8": ""
    }
  }, [_vm.user ? _c('v-card-text', [_vm._v("\n            Mobile Engineer\n          ")]) : _vm._e()], 1), _c('v-flex', {
    staticClass: "blue-grey lighten-5",
    attrs: {
      "xs4": ""
    }
  }, [_c('v-card-text', [_c('strong', [_vm._v(_vm._s(_vm.$vuetify.t('$vuetify.powra.sign')) + ":")])])], 1), _c('v-flex', {
    staticClass: "blue-grey lighten-5 text-xs-left",
    attrs: {
      "xs8": ""
    }
  }, [_c('v-card-text', [_vm.currentSignature ? _c('div', [_vm._v("\n              Current signature\n              "), _c('v-img', {
    staticClass: "white lighten-2 media",
    attrs: {
      "src": _vm.currentSignature
    }
  }, [_c('v-layout', {
    attrs: {
      "slot": "placeholder",
      "fill-height": "",
      "align-center": "",
      "justify-center": "",
      "ma-0": ""
    },
    slot: "placeholder"
  }, [_c('v-progress-linear', {
    attrs: {
      "indeterminate": "",
      "color": "grey lighten-5"
    }
  })], 1)], 1)], 1) : _vm._e(), _c('signature-pad', {
    attrs: {
      "buttonText": "Signature",
      "callId": _vm.callDetail.id,
      "title": "Sign the Document",
      "signatureType": "signoff_signature",
      "onlyEvent": true
    },
    on: {
      "signature-updated": _vm.signatureUpdated
    }
  })], 1)], 1), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-card-text', [_c('strong', [_vm._v(_vm._s(_vm.$vuetify.t('$vuetify.powra.date')) + ":")])])], 1), _c('v-flex', {
    attrs: {
      "xs8": ""
    }
  }, [_c('v-card-text', [_vm._v("\n            " + _vm._s(_vm.moment().format('DD/MM/YYYY')) + "\n          ")])], 1)], 1), _c('div', {
    staticClass: "footer text-xs-center mb-3"
  }, [_c('v-divider'), _c('v-card-text', [_c('v-btn', {
    on: {
      "click": function click($event) {
        return _vm.back();
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$vuetify.t('$vuetify.calls.back')) + "\n          ")]), _c('v-btn', {
    attrs: {
      "color": "success"
    },
    on: {
      "click": function click($event) {
        return _vm.confirm();
      }
    }
  }, [_vm._v("\n            " + _vm._s(this.hasPowra ? _vm.$vuetify.t('$vuetify.calls.save') : _vm.$vuetify.t('$vuetify.calls.proceedToTheNextSection')) + "\n          ")]), _c('abort-visit', {
    on: {
      "aborted": function aborted($event) {
        return _vm.visitAborted();
      }
    }
  })], 1)], 1)], 1)], 1), _c('v-dialog', {
    attrs: {
      "width": "500"
    },
    model: {
      value: _vm.errorDialog,
      callback: function callback($$v) {
        _vm.errorDialog = $$v;
      },
      expression: "errorDialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline red white--text",
    attrs: {
      "primary-title": ""
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$vuetify.t('$vuetify.permissionToWork.checkSignature')) + "\n      ")]), _c('v-card-text', [_c('v-container', {
    attrs: {
      "pa-1": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "shrink": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "red",
      "x-large": ""
    }
  }, [_vm._v("warning")])], 1), _c('v-flex', {
    attrs: {
      "pl-3": ""
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$vuetify.t('$vuetify.permissionToWork.addSignature')) + "\n            ")])], 1)], 1)], 1), _c('v-divider'), _c('v-card-actions', [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "color": "primary",
      "flat": ""
    },
    on: {
      "click": function click($event) {
        _vm.errorDialog = false;
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$vuetify.t('$vuetify.app.ok')) + "\n        ")])], 1)], 1)], 1), _c('v-dialog', {
    attrs: {
      "width": "500"
    },
    model: {
      value: _vm.confirmationDialog,
      callback: function callback($$v) {
        _vm.confirmationDialog = $$v;
      },
      expression: "confirmationDialog"
    }
  }, [_c('v-card', [_vm.user ? _c('v-card-title', {
    staticClass: "headline red white--text",
    attrs: {
      "primary-title": ""
    }
  }, [_vm._v("\n        " + _vm._s(_vm.user.full_name) + "\n      ")]) : _vm._e(), _c('v-card-text', [_c('v-container', {
    attrs: {
      "pa-1": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "shrink": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "red",
      "x-large": ""
    }
  }, [_vm._v("warning")])], 1), _c('v-flex', {
    attrs: {
      "pl-3": ""
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$vuetify.t('$vuetify.saveNewPowra.confirmationMessage')) + "\n            ")])], 1)], 1)], 1), _c('v-divider'), _c('v-card-actions', [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "color": "red",
      "flat": ""
    },
    on: {
      "click": function click($event) {
        _vm.confirmationDialog = false;
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$vuetify.t('$vuetify.app.no')) + "\n        ")]), _c('v-btn', {
    attrs: {
      "color": "green",
      "flat": ""
    },
    on: {
      "click": function click($event) {
        return _vm.submitPowra();
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$vuetify.t('$vuetify.app.yes')) + "\n        ")])], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }